import React from 'react';
import PropTypes from 'prop-types';
import MarkerIcon from './icon';
import styles from '../styles.less';

const Marker = ({ active, onClick, onMouseEnter, onMouseLeave, count, ...props }) => (
  <div
    className={[styles.marker, active ? styles.active : null].join(' ')}
    onMouseEnter={onMouseEnter}
    onMouseLeave={onMouseLeave}
    onClick={onClick}
  >
    <span className={styles.counter}>{!!count && count}</span>
    <MarkerIcon {...props} />
  </div>
);

Marker.propTypes = {
  lat: PropTypes.any.isRequired,
  lng: PropTypes.any.isRequired,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  onClick: PropTypes.func,
  active: PropTypes.bool,
  count: PropTypes.number,
};

Marker.defaultProps = {
  onClick: () => null,
  onMouseEnter: () => null,
  onMouseLeave: () => null,
  active: false,
  count: 0,
};
export default React.memo(Marker);
